import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentforpune() {



  const cardData =
  {
    keyword: 'Tempo Traveller On Rent for Pune Darshan ',
    heading: 'Sanavi Travels: Tempo Traveller On Rent for Pune Darshan',
    headingDescription: 'Sanavi Travels offers reliable Tempo Traveller on Rent for Pune Darshan, providing safe, comfortable, and hassle-free group travel for families, tourists, corporate guests, and educational groups exploring the city of Pune. Our well-maintained fleet of 9, 12, 13, 17, and 20 seater tempo travellers is ideal for full-day and multi-day Pune sightseeing tours, offering spacious seating, air-conditioned comfort, and ample luggage space. With experienced local chauffeurs familiar with Pune routes and tourist attractions, flexible hourly and daily rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth and enjoyable Pune Darshan experience. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to popular attractions such as Shaniwar Wada, Dagdusheth Halwai Ganpati, Aga Khan Palace, Sinhagad Fort, Parvati Hill, and nearby destinations, Sanavi Travels provides trusted Tempo Traveller rental services for Pune Darshan, ensuring comfort, safety, and a memorable city tour.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,




"services": [
    {
      "name": "Tempo Traveller On Rent for Pune Darshan",
      "description": "Tempo Traveller On Rent for Pune Darshan provides reliable and spacious vehicles for group sightseeing in Pune. Ideal for families, friends, or corporate groups, these vehicles ensure comfort, safety, and timely travel. Professional drivers guide passengers through Pune’s key attractions, offering a convenient and stress-free sightseeing experience with flexible booking options and transparent pricing."
    },
    {
      "name": "Pune Darshan Tempo Traveller Hire",
      "description": "Pune Darshan Tempo Traveller Hire offers flexible rental services for city tours in Pune. Vehicles are well-maintained, comfortable, and equipped with ample seating and luggage space. Experienced drivers manage routes efficiently, ensuring passengers can enjoy Pune’s temples, historical landmarks, and cultural attractions without worrying about navigation or traffic."
    },
    {
      "name": "AC Tempo Traveller Pune City Tour",
      "description": "AC Tempo Traveller Pune City Tour provides air-conditioned vehicles for a cool and comfortable sightseeing experience. Perfect for long tours, family outings, or corporate visits, these vehicles offer spacious interiors and luggage-friendly designs. Professional chauffeurs ensure safe driving and optimized routes, allowing passengers to relax and enjoy Pune’s city tour in comfort and style."
    },
    {
      "name": "Luxury Tempo Traveller Pune Darshan",
      "description": "Luxury Tempo Traveller Pune Darshan offers premium vehicles for an elegant and comfortable travel experience around Pune. Equipped with reclining seats, entertainment systems, and ample luggage space, these vehicles are ideal for VIP trips, corporate groups, or family outings. Skilled drivers ensure punctuality, safety, and a smooth journey while exploring Pune’s cultural and historical landmarks."
    },
    {
      "name": "Family Tempo Traveller Pune Sightseeing",
      "description": "Family Tempo Traveller Pune Sightseeing ensures a safe and comfortable experience for families visiting Pune. Vehicles provide spacious seating, luggage space, and child-friendly amenities for a stress-free journey. Experienced drivers follow scenic and safe routes, making it convenient for family vacations, weekend trips, or guided sightseeing tours across Pune’s top attractions."
    },
    {
      "name": "Corporate Pune Darshan Tempo Traveller",
      "description": "Corporate Pune Darshan Tempo Traveller caters to office groups and business travelers exploring Pune. Vehicles come with premium interiors, comfortable seating, and amenities for relaxation or productivity. Chauffeurs maintain punctuality and safety, making it perfect for corporate visits, team outings, or client entertainment while touring Pune’s landmarks efficiently and professionally."
    },
    {
      "name": "Affordable Tempo Traveller Pune Tour",
      "description": "Affordable Tempo Traveller Pune Tour offers budget-friendly rental options for groups exploring Pune. Well-maintained and spacious, these vehicles ensure a smooth and safe travel experience. Ideal for families, friends, or corporate teams seeking economical transport, this service combines affordability, convenience, and reliable service for city tours and sightseeing excursions."
    },
    {
      "name": "Chauffeur Driven Tempo Traveller Pune",
      "description": "Chauffeur Driven Tempo Traveller Pune provides skilled drivers for hassle-free travel across Pune. Passengers can relax while drivers handle city traffic, routes, and navigation. Spacious and comfortable vehicles accommodate families, friends, or corporate groups, offering safety, convenience, and peace of mind during Pune city tours or group outings."
    },
    {
      "name": "Group Travel Pune Darshan",
      "description": "Group Travel Pune Darshan caters to large groups visiting Pune’s attractions. Vehicles are spacious, well-maintained, and ideal for comfortable group transport. Professional drivers ensure smooth navigation, timely arrivals, and safe journeys, making sightseeing tours, cultural visits, or corporate outings convenient, enjoyable, and stress-free for all passengers."
    },
    {
      "name": "Best Tempo Traveller Pune Sightseeing",
      "description": "Best Tempo Traveller Pune Sightseeing offers top-quality vehicles and professional service for a superior Pune city tour experience. Comfortable interiors, experienced drivers, and attention to passenger convenience ensure a smooth and enjoyable journey. Perfect for families, friends, and corporate groups exploring Pune’s historical, cultural, and tourist attractions."
    },
    {
      "name": "Pune Local Tour Tempo Traveller",
      "description": "Pune Local Tour Tempo Traveller provides dependable vehicles for short city tours within Pune. Vehicles are spacious, well-maintained, and equipped for comfort, allowing passengers to explore key attractions efficiently. Skilled drivers manage city traffic and routes, ensuring a stress-free and enjoyable local sightseeing experience."
    },
    {
      "name": "One Day Pune Darshan Tempo Traveller",
      "description": "One Day Pune Darshan Tempo Traveller offers vehicles for single-day sightseeing trips in Pune. Ideal for families, friends, or corporate groups, these vehicles provide comfort, ample seating, and luggage space. Professional drivers ensure timely pick-ups and drop-offs, allowing passengers to enjoy Pune’s key attractions in a convenient and organized manner."
    },
    {
      "name": "Tourist Tempo Traveller Pune",
      "description": "Tourist Tempo Traveller Pune caters specifically to tourists exploring Pune. Vehicles are spacious, comfortable, and equipped for long sightseeing trips. Experienced drivers provide safe and reliable transport, helping passengers visit temples, historical sites, and cultural attractions conveniently and efficiently while enjoying a stress-free travel experience."
    },
    {
      "name": "Pune City Travel Vehicle",
      "description": "Pune City Travel Vehicle offers dependable transport for individuals and groups touring Pune. Spacious and comfortable, these vehicles are maintained for safety and long-distance comfort. Professional drivers handle routes efficiently, ensuring a smooth and enjoyable sightseeing experience for families, friends, or corporate travelers."
    },
    {
      "name": "Tempo Traveller Rental Pune",
      "description": "Tempo Traveller Rental Pune provides well-maintained vehicles for flexible rental options in Pune. Perfect for city tours, group outings, or family sightseeing trips, these vehicles offer comfort, ample seating, and luggage space. Skilled drivers ensure punctuality, safety, and a stress-free journey, making Pune travel convenient, reliable, and enjoyable."
    }
  ],
  "tableData": [
    ["Tempo Traveller On Rent for Pune Darshan", "Pune Darshan Tempo Traveller Hire"],
    ["AC Tempo Traveller Pune City Tour", "Luxury Tempo Traveller Pune Darshan"],
    ["Family Tempo Traveller Pune Sightseeing", "Corporate Pune Darshan Tempo Traveller"],
    ["Affordable Tempo Traveller Pune Tour", "Chauffeur Driven Tempo Traveller Pune"],
    ["Group Travel Pune Darshan", "Best Tempo Traveller Pune Sightseeing"],
    ["Pune Local Tour Tempo Traveller", "One Day Pune Darshan Tempo Traveller"],
    ["Tourist Tempo Traveller Pune", "Pune City Travel Vehicle"],
    ["Tempo Traveller Rental Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Tempo Traveller on Rent for Pune Darshan with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable Tempo Traveller on rent for Pune Darshan, ideal for family outings, group tours, corporate visits, and local sightseeing."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Tempo Travellers",
    "WhyChoosedescription": "Explore Pune comfortably in spacious, air-conditioned, and well-maintained Tempo Travellers designed for a relaxed sightseeing experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Darshan",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with Pune sightseeing routes and major attractions, ensuring smooth and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Tempo Traveller rentals for Pune Darshan, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and sightseeing queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized Tempo Traveller rental plans for Pune Darshan."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Tempo Travellers are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic sightseeing experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Tempo Traveller on rent for Pune Darshan."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Tempo Traveller on rent for Pune Darshan?',
    answer: 'Yes, Sanavi Travels offers comfortable and well-maintained Tempo Travellers for Pune Darshan sightseeing.'
  },
  {
    question: 'How can I book a Tempo Traveller for Pune Darshan with Sanavi Travels?',
    answer: 'You can book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacities are available for Pune Darshan Tempo Traveller?',
    answer: 'We offer Tempo Travellers with different seating capacities suitable for small and large groups.'
  },
  {
    question: 'Are drivers included for Pune Darshan Tempo Traveller rentals?',
    answer: 'Yes, all Tempo Traveller rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the Tempo Traveller service for Pune Darshan available 24x7?',
    answer: 'Yes, our Tempo Traveller rental service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before Pune Darshan trips?',
    answer: 'Yes, all Tempo Travellers are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune Darshan sightseeing itinerary?',
    answer: 'Absolutely. Sanavi Travels offers customized Pune Darshan sightseeing plans as per your requirements.'
  },
  {
    question: 'What payment options are available for Pune Darshan Tempo Traveller bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during Pune Darshan trips?',
    answer: 'Yes, our 24x7 customer support team is available throughout your sightseeing tour.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Bhosale',
    feedback: 'Booked a Tempo Traveller for Pune Darshan with Sanavi Travels. Comfortable vehicle and knowledgeable driver made the trip enjoyable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Rao',
    feedback: 'Excellent service by Sanavi Travels. Clean Tempo Traveller and well-planned Pune Darshan tour.',
    rating: 5
  }
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent for Pune Darshan - Sanavi Travels",
  "description": "Tempo traveller on rent for Pune Darshan by Sanavi Travels for city sightseeing, local tours, family outings, corporate visits, and group travel. Choose AC and luxury tempo travellers for a comfortable and affordable one-day Pune Darshan experience.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2975"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Tempo Traveller On Rent for Pune Darshan Starting from ₹28 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book tempo traveller on rent for Pune Darshan with Sanavi Travels. AC and luxury tempo traveller for Pune city tour, sightseeing, family and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentforpune;